export const SHOW_INVOICE_PAGES = 'ShowInvoicePages'

/** Feature flag keys (const object avoids @typescript-eslint/no-duplicate-enum-values rule bug on large enums) */
export const SPLITS = {
  USE_NEW_SAVED_ADDRESSED: 'NewGmSavedAddresses',
  REMOVE_ITEM_NOTES: 'removeItemNotes',
  BUDGET_CODE_MANDATORY: 'GmMandatoryBudgetCode',
  AUTOPILOT: 'autopilot',
  FLEXINVOICING: 'FlexInvoicing',
  USE_ACCOUNT_COUNTRY_FLEX_MAPPING: 'useAccountCountryFlexMapping',
  SAME_DAY_GM_DELIVERY: 'sameDayGmDelivery',
  RESELLER_MODEL: 'ResellerModel',
  DYNAMIC_NAVIGATION: 'DynamicNavigation',
  IRELAND_IS_LIVE: 'IrelandLive',
  PRICES_EX_TAX_GM: 'showPricesExcludingTaxGm',
  FEEDR_INVOICING_RESELLER: 'feedrInvoicingReseller',
  FEEDR_INVOICING_RESELLER_V2: 'reseller_v2',
  PRICES_EX_TAX_MENU_MANAGER: 'menuManagerPricesExTax',
  DEFERRED_PAYMENT: 'deferGmPayments',
  FILTER_UPCOMING_ORDERS: 'vpUpcomingOrdersDateFilter',
  EXPRESS_CHECKOUT_GM: 'gmExpressCheckout',
  COUNTRY_SPECIFIC_FILTERS_GM: 'countrySpecificFiltersGm',
  FIVE_STAR_RATINGS: 'useFiveStarRatings',
  SHOW_HIGHLIGHTS_GM: 'showHighlightsGm',
  SHOW_POPULAR_ITEMS_GM: 'showPopularItemsGm',
  SHOW_DIVERSITY_TAGS_GM: 'showDiversityTagsGm',
  MENU_ITEM_MUTATIONS_VP: 'useMenuItemMutationsVendorPortal',
  MENU_ITEM_QUERIES_VP: 'menuManagerUseMenuItemQueriesVendorPortal',
  CATERING_ORDER_DUPLICATION: 'CateringOrderDuplication',
  USER_CANCEL_DUPLICATE_CATERING_ORDER_CARD: 'UserCancelDuplicateCateringOrderCard',
  MIN_ORDER_VALUE_EX_TAX: 'MinOrderValueExTax',
  MENU_ITEM_GROUPING_VP: 'menuItemGroupingVp',
  MENU_ITEM_GROUPING: 'menuItemGrouping',
  SHOW_UPDATED_ONBOARDING_LINKS: 'showUpdatedOnboardingLinks',
  CUSTOMER_AUTO_INVOICE: 'customerAutoInvoice',
  USE_SYNCHRONOUS_CC_ORDER_PLACEMENT: 'useSynchronousCanteenOrderPlacementWeb',
  GM_ITEM_CATEGORY_ARRAY: 'GMItemCategoryArray',
  USE_SERVER_SIDE_CANTEEN_MENU_CLOSED_LOGIC: 'useServerSideCanteenMenuClosedLogic',
  CUSTOMER_SPLIT_INVOICE: 'customerSplitInvoice',
  GM_CUTOFF_5PM: 'gmCutOff5pm',
  IA_REFUND_CATERING_ORDER_CARD: 'iaRefundCateringOrderCard',
  CANCELLATION_CONFIRMATION_MODAL: 'internalAdminCateringCancellationReasonModal',
  MUI_GM_ORDER_VIEW_VP: 'useMuiGmOrderViewVP',
  CUSTOMER_ADMIN_REPORTING: 'customerAdminReporting',
  ENTERPRISE_DISCOUNTS: 'EnterpriseDiscounts',
  USE_PANTRY_VENDOR_TYPE_DROPDOWN: 'UsePantryVendorTypeDropdown',
  TENANT_TRANSPORT_TYPES: 'TenantTransportTypes',
  USER_STANDING_ORDER_EDIT_ENABLED: 'userStandingOrderEditEnabled',
  REFERENCE_FIELD_COLUMNS_CUSTOMER_CREATE_INVOICE: 'ReferenceFieldColumnsCustomerCreateInvoice',
  INTERNAL_ADMIN_SSO: 'InternalAdminSSO',
  GM_INTERNAL_ADMIN_ORDER_NOTES: 'GmInternalAdminOrderNotes',
  APPORVE_SUPPLIERS: 'ApprovedSuppliers',
  GM_SHOW_FULL_ADDRESS: 'gmShowFullAddress',
  USER_SEND_QUOTE_MODAL: 'UserSendQuoteModal',
  ACCOUNT_CREDIT_CARD_FEE_TOGGLE: 'AccountCreditCardFeeToggle',
  REFRESHED_ACOUNT_FINANCE_SETTINGS_INVOICE_LIST: 'RefreshedAccountFinanceSettingsInvoiceList',
  ACCOUNT_FINANCE_INVOICE_ACCOUNT_AUTO_PAY_TOGGLE: 'AccountFinanceInvoiceAccountAutoPayToggle',
  MULTI_QUOTES: 'MultiQuotes',
  SUPPLIER_CANNOT_DELIVER_TO_ADDRESS_MODAL_INTERNAL_ADMIN:
    'SupplierCannotDeliverToAddressModalInternalAdmin',
  INCLUDE_CUSTOMER_REFUND_TO_ORDER_TOTAL: 'includeCustomerRefundToOrderTotal',
  INCLUDE_VENDOR_CHARGE_TO_ORDER_TOTAL: 'includeVendorChargeToOrderTotal',
  CATERDESK_ADMIN: 'caterdeskAdmin',
  DISPLAY_MARGIN: 'displayMargin',
  USE_DYNAMIC_MARKETPLACE_HEADER_IMAGES: 'useDynamicMarketplaceHeaderImages',
  EMMA_EDIT_RESPONSE: 'editEmmaResponse',
  MULTIPLE_BASKETS_GM_MARKETPLACE: 'multipleBasketsOnGmMarketplace',
  CATERING_REORDER_MENU_PAGE: 'cateringReorderMenuPage',
  MANDATORY_REFERENCE_FIELDS_DISCLAIMER_MODAL_INTERNAL_ADMIN:
    'MandatoryReferenceFieldsDisclaimerModalInternalAdmin',
  CUSTOMER_STANDING_ORDER_INVOICING_RULES: 'customerStandingOrderInvoicingRules',
  MULTI_SELECT_ORDER_TYPES_INTERNAL_ADMIN: 'MultiSelectOrderTypesInternalAdmin',
  MARKETPLACE_COUNTRY_DROPDOWN: 'marketplaceCountryDropdown',
  NEW_MARKETPLACE_SIGNED_IN_DROPDOWN: 'NewMarketplaceSignedInDropdown',
  ADVANCED_STANDING_ORDER_INVOICING_SETTINGS: 'advancedStandingOrderInvoicingSettings',
  AUTOFILL_BASKET_FROM_EMPTY_EMMA_QUOTE: 'AutofillBasketFromEmptyEmmaQuote',
  EMMA_BUDGET_THRESHOLD: 'EmmaBelowBudgetThresholdQuoteForm',
  VENDOR_PORTAL_ORDER_LIST_IMPROVEMENTS: 'VendorPortalOrderListImprovements',
  SHOW_INVOICE_RECIPIENT_SETTINGS: 'ShowInvoiceRecipientSettings',
  MixPanel: 'MixPanel',
  ALWAYS_SHOW_ACCOUNT_DROPDOWN: 'AlwaysShowAccountDropdown',
  SHOW_CHARGE_COMMISSION_ON_DELIVERY_FEES: 'ShowChargeCommissionOnDeliveryFees',
  CUSOTMER_ORDER_REPORT_PIE_CHART_THEME_V2: 'CustomerOrderReportPieChartThemeV2',
  ALLOW_TRANSFER_PAYMENTS: 'AllowTransferPayments',
  ADMIN_ACCOUNT_AND_SUPPLIER_FILTERS: 'adminAccountAndSupplierFilters',
  ADMIN_ACCOUNT_AND_SUPPLIER_VALUE_INSIGHTS: 'adminAccountAndSupplierValueInsights',
  DIVERSITY_SPEND_LOGIC_TOGGLE: 'DiversitySpendLogicToggle',
  VENDOR_NEWMARKETPLACE_SORT: 'VendorNewMarketplaceSort',
  MIX_PANEL_INDIVIDUAL_EVENTS: 'MixpanelIndividualEvents',
  INTERNAL_ADMIN_SUBMENU_FUSION_MOVE: 'internalAdminSubmenuFusionMove',
  GLOBAL_SEARCH: 'globalSearch',
  CATERING_TEAM_ORDER: 'groupOrdering',
  MENU_WIZARD: 'MenuWizard',
  PLATFORM_ALERTS: 'platformAlertsSystem',
  USER_DASHBOARD_PAGES_MOVE_OCT_2025: 'userDashboardPagesToFusion',
  USE_NEW_CLOUD_CANTEEN_UI: 'useNewCloudCanteenUI',
  CC_APP_PROMO: 'ccAppPromo',
  SHOW_NEW_BUDGET_EMMA: 'showNewBudgetEmma',
  SYNC_INSTANT_ORDER_AS_ADMIN_IN_ADMIN_GM_ORDER_EDITOR:
    'SyncInstantOrderAsAdminInAdminGmOrderEditor',
  ADMIN_ACCOUNT_FINANCE_COST_PLUS_PRICING_TOGGLE: 'AdminAccountFinanceCostPlusPricingToggle',
  SHOW_ADMIN_LIST_USER_CREATE_USER_DIALOG_REASON_FOR_SIGNUP_SELECT_FIELD:
    'ShowAdminListUserCreateUserDialogReasonForSignupSelectField',
  CONSOLIDATED_FINANCE_PAGE: 'consolidatedFinancePage',
  GM_ORDER_TYPE_NEW_PRODUCT_FEES: 'NewGMOrderTypeProductFees',
  SHOW_BEST_FOR_TAGS_GM: 'showBestForTagsGm',
  SHORT_LEAD_TIME_POP_UP: 'ShortLeadTimePopUp',
  LEGACY_PAYMENT_PAGE: 'legacyPaymentPage',
  SHOW_ALLERGENS_ON_CHECKOUT: 'showAllergensOnCheckout',
  SHOW_ALLERGENS_ON_ORDER_EDIT: 'showAllergensOnOrderEdit',
  USE_BASKET_SHARING_VALIDATION: 'useBasketSharingValidation',
  FUSION_MENU_MANAGER: 'fusionMenuManagerRebuildRedirect',
  CALENDAR_PAGE_FUSION: 'calendarPageFusion',
  DASHBOARD_SIDEBAR_NAV: 'dashboardSidebarNav',
  INTERNAL_ADMIN_ACCOUNT_MENU_AUTOMATION_PAGE: 'internalAdminAccountMenuAutomationPage',
  MENU_AUTOMATION_CONSTRAINTS: 'MenuAutomationConstraints',
  USE_CANTEEN_MENU_CREDIT_FILTER: 'useCanteenMenuCreditFilter',
  INTERNAL_ADMIN_MENU_LIST_PAGE_FUSION: 'internalAdminMenuListPageFusion',
  INTERNAL_ADMIN_MENU_OVERVIEW_PAGE_FUSION: 'internalAdminMenuOverviewPageFusion',
  INTERNAL_ADMIN_ACCOUNTS_MIGRATION: 'internalAdminAccountsMigration',
  CC_ITEM_RATING: 'ccItemRating',
  GM_ORDER_RATING_DISPLAY: 'gmOrderRatingDisplay',
  INTERNAL_ADMIN_ROADMAP_LINK: 'internalAdminRoadmapLink',
  INTERNAL_ADMIN_TENANT_LINKS: 'internalAdminTenantLinks',
  PAYMENT_PAGE_SAVED_CARD_MANAGEMENT: 'paymentPageSavedCardManagement',
  ACCOUNT_ARCHIVE: 'accountArchive',
  VENDOR_PORTAL_REDESIGN: 'vendorPortalRedesign',
  ACCOUNT_MINIMUM_CATERING_SPEND_MONTHLY_FIELD: 'accountMinimumCateringSpendMonthlyField',
  MIXPANEL_ITEM_ADDED_TO_BASKET: 'mixpanelItemAddedToBasket',
  MIXPANEL_LOAD_PAST_ORDER: 'mixpanelLoadPastOrder',
  SHOW_SORT_FOR_CC_MENU: 'showSortForCcMenu',
  USE_CC_REORDER_SECTION: 'useCcReorderSection',
  VENDOR_LOCATION_CAPACITY_OVERRIDE: 'vendorLocationCapacityOverride',
  USE_ITEM_NOTES_IN_BASKET: 'useItemNotesInBasket',
  GM_COMBINED_ITEM_SEARCH: 'gmCombinedItemSearch',
} as const

export type SplitKey = (typeof SPLITS)[keyof typeof SPLITS]
